import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import cookie from 'react-cookie';
import {toastr} from 'react-redux-toastr';

export default function(WrappedComponent) {
  class MemberZone extends Component {
    constructor(props, context) {
      super(props, context);
    }

    componentWillReceiveProps(nextProps) {
      if (!nextProps.auth || !nextProps.auth.isAuthenticated) {
        this.props.history.push('/signin');
      }
    }

    render() {
      if (this.props.auth && this.props.auth.isAuthenticated) {
        return <WrappedComponent ref='wrappedComponent' {...this.props}/>;
      } else {
        if (typeof cookie.load('accessToken') == 'undefined') {
          let instance = new WrappedComponent;

          //toastr.error("Lỗi", "Bạn cần phải đăng nhập trước khi đăng ký thông tin doanh nghiệp");

          if (typeof instance.onUnauthorized == 'function') {
            instance.onUnauthorized().then(() => {
              this.props.history.push('/signin');
            })
          } else {
            this.props.history.push('/signin');
          }

          return null;
        } else {
          return null;
        }

      }
    }
  }

  const bindStateToProps = state => {
    return {
      auth: state.auth
    }
  }

  return withRouter(connect(bindStateToProps)(MemberZone));
}



// WEBPACK FOOTER //
// ./pages/users/MemberZone.jsx